export default __webpack_public_path__ + "static/media/loader-logo-circle-w.5cc12367.png";